module.exports = __webpack_public_path__ + "static/media/ibeacon.f6410c56.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/ibeacon.png
 ** module id = 226
 ** module chunks = 0
 **/